import { ref } from 'vue'
import type { ShopUser } from '@scayle/storefront-nuxt'
import { useCurrentShop } from '#storefront/composables'

const murId = ref<string | undefined>(undefined)
const isFetching = ref(false)

export const useMurId = ({ user }: { user: ShopUser | undefined }) => {
  if (user?.referenceKey) {
    murId.value = user.referenceKey
  }

  const currentShop = useCurrentShop()
  const shopId = currentShop.value.shopId

  const getMurId = async () => {
    const isValidUser = user && user.email && !user?.status?.isGuestCustomer

    if (!isValidUser || isFetching.value) {
      return
    }

    if (murId.value) {
      return murId.value
    }

    isFetching.value = true

    const { referenceKey } = (await $fetch(
      `/api/snipes/mur-id/${shopId}/${encodeURIComponent(
        user.email as string,
      )}`,
    )) as { referenceKey: string }

    if (!referenceKey) {
      console.error('Error fetching murId')
    }

    murId.value = referenceKey
    isFetching.value = false

    return murId.value
  }

  return {
    murId,
    getMurId,
  }
}
